﻿import { Component, OnInit, AfterViewInit, ViewChild, TemplateRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DataTableColumn } from '../../../../shared/ui/data-table/data-table.component';
import { SellerService, LocalService } from '../../../../core';

@Component({
  selector: 'app-standard-incentives',
  templateUrl: './standard-incentives.component.html',
  styleUrls: ['./standard-incentives.component.scss']
})
export class StandardIncentivesComponent implements OnInit, AfterViewInit {

  @ViewChild('challengePeriodTpl') challengePeriodTpl: TemplateRef<any> | undefined = undefined;
  @ViewChild('stdDescriptionTpl') stdDescriptionTpl: TemplateRef<any> | undefined = undefined;
  @ViewChild('stdAwardTpl') stdAwardTpl: TemplateRef<any> | undefined = undefined;

  columns: DataTableColumn[] = [];
  page = 1;
  readonly pageSize = 5;
  isLoading = false;
  data: any = { content: [], totalElements: 0 };

  userProfile: any;
  pamData: any = '';

  constructor(
    private sanitizer: DomSanitizer,
    private sellerService: SellerService
  ) {}

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');
    if (this.userProfile.hasOwnProperty('userType') && this.userProfile.userType === 'PAM') {
      this.pamData = LocalService.get('pamData');
      if (!this.pamData) {
        this.pamData = this.userProfile.pamDefaultSelection;
      }
    }
    this.loadData();
  }

  ngAfterViewInit() {
    setTimeout(() => { this.buildColumns(); });
  }

  htmlProperty(html: string) {
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  private get beGeoId(): string {
    if (this.pamData === '') {
      return this.userProfile.company.beGeoId;
    }
    const beGeoIds = this.pamData.pamBeGeoIdsDTO ? this.pamData.pamBeGeoIdsDTO.beGeoIds : this.pamData.beGeoIds;
    const first = (beGeoIds.content && beGeoIds.content.length > 0) ? beGeoIds.content[0] : (beGeoIds.length > 0 ? beGeoIds[0] : null);
    return first ? first.beGeoId : this.userProfile.company.beGeoId;
  }

  private buildParams(page: number) {
    return {
      region: this.userProfile.company.region,
      beGeoId: this.beGeoId,
      page: page,
      size: this.pageSize,
      console: localStorage.getItem('selectedRole') === 'manager' ? 'LEADER' : 'SELLER',
    };
  }

  loadData() {
    this.fetchPage(0);
  }

  onPageChange(pageNumber: number) {
    this.page = pageNumber;
    this.fetchPage(this.page - 1);
  }

  private fetchPage(page: number) {
    this.isLoading = true;
    this.sellerService.getStandardIncentives(this.buildParams(page)).subscribe(
      (data:any) => {
        this.data = data;
        this.isLoading = false;
      },
      () => {
        this.isLoading = false;
      }
    );
  }

  buildColumns() {
    this.columns = [
      { field: 'challengePeriod', header: 'Challenge Period', align: 'left', cellTemplate: this.challengePeriodTpl },
      { field: 'name', header: 'Name', align: 'left' },
      { field: 'description', header: 'Description', align: 'left', cellTemplate: this.stdDescriptionTpl },
      { field: 'award', header: 'Sales Rewards', align: 'left', cellTemplate: this.stdAwardTpl },
    ];
  }
}
